(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["k-wholesale-order"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('kareno-wholesale-order'))customElements.define('kareno-wholesale-order',class extends HTMLElement{
 connectedCallback(){
  if(this.started)return;this.started=true;this.data=JSON.parse(this.querySelector('[data-order-data]').textContent);this.labels=this.data.labels;this.quantities=new Map();this.busy=false;this.preview=this.dataset.preview==='true';this.ready=this.preview;this.money=n=>new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:this.data.currency||'USD'}).format(n/100);
  this.addEventListener('input',e=>{if(e.target.matches('input[data-variant]')){e.target.setCustomValidity('');this.quantities.set(Number(e.target.dataset.variant),Number(e.target.value));this.update()}});
  this.addEventListener('click',e=>{const b=e.target.closest('button');if(!b||b.disabled)return;if(b.hasAttribute('data-add-all'))this.add();if(b.hasAttribute('data-add-row'))this.add(b.dataset.addRow);if(b.hasAttribute('data-clear')){this.quantities.clear();this.render()}});
  this.render();if(!this.preview){this.refresh().catch(()=>this.failRefresh());this.timer=setInterval(()=>{if(!this.busy&&!document.hidden)this.refresh().catch(()=>this.failRefresh())},30000)}
 }
 disconnectedCallback(){clearInterval(this.timer);this.controller?.abort()}
 node(tag,text,cls){const n=document.createElement(tag);if(text!==undefined)n.textContent=text;if(cls)n.className=cls;return n}
 group(v){return v.options.filter((_,i)=>i!==this.data.sizeIndex).join(' / ')||this.labels.variant}
 size(v){return this.data.sizeIndex<0?this.labels.variant:v.options[this.data.sizeIndex]}
 limit(v){let max=v.max===null?Infinity:Math.max(0,v.max-v.inCart);if(v.tracked&&v.policy==='deny')max=Math.min(max,Math.max(0,v.stock-v.inCart));if(!v.available)max=0;return max}
 price(v,q){let price=v.price;for(const b of [...v.breaks].sort((a,b)=>a.quantity-b.quantity))if(q>=b.quantity)price=b.price;return price}
 valid(v,q){const total=q+v.inCart;return q===0||(Number.isInteger(q)&&q>0&&v.available&&q<=this.limit(v)&&total>=v.min&&total%v.step===0)}
 render(){
  const active=this.contains(document.activeElement)?document.activeElement?.dataset.variant:null;const sizes=[...new Set(this.data.variants.map(v=>this.size(v)))];const groups=[...new Set(this.data.variants.map(v=>this.group(v)))];const head=this.querySelector('thead');head.replaceChildren();const hr=this.node('tr');for(const label of [this.data.sizeIndex<0?this.labels.variant:this.labels.color,...sizes,this.labels.rowTotal]){const th=this.node('th',label);th.scope='col';hr.append(th)}head.append(hr);const body=this.querySelector('tbody');body.replaceChildren();
  for(const group of groups){const row=this.node('tr');const th=this.node('th',group);th.scope='row';const swatches={black:'#171717',white:'#f5f4f0',navy:'#202a43',charcoal:'#555651'};const swatch=swatches[group.toLowerCase()];if(swatch){const chip=this.node('span',undefined,'kwo-swatch');chip.style.background=swatch;th.prepend(chip)}row.append(th);
   for(const size of sizes){const td=this.node('td');const v=this.data.variants.find(v=>this.group(v)===group&&this.size(v)===size);if(!v){td.textContent='—';row.append(td);continue}const input=this.node('input');input.type='number';input.inputMode='numeric';input.min=0;input.step=1;input.value=this.quantities.get(v.id)||0;input.dataset.variant=v.id;input.setAttribute('aria-label',group+' '+size);const limit=this.limit(v);if(Number.isFinite(limit))input.max=limit;input.disabled=this.preview||this.busy||!this.ready||limit===0;td.append(input);
    const stock=v.tracked?Math.max(0,v.stock):this.labels.inStock;td.append(this.node('small',this.labels.available+': '+stock));if(!v.available)td.append(this.node('small',this.labels.sold));else if(v.tracked&&v.stock<=0&&v.policy==='continue')td.append(this.node('small',this.labels.backorder));if(v.inCart)td.append(this.node('small',this.labels.inCart+': '+v.inCart));const price=this.node('span','', 'kwo-price');price.dataset.price=v.id;td.append(price);
    const rules=[];if(v.min>1)rules.push(this.labels.minimum+' '+v.min);if(v.step>1)rules.push(this.labels.multiple+' '+v.step);if(v.max!==null)rules.push(this.labels.maximum+' '+v.max);if(rules.length)td.append(this.node('small',rules.join(' · ')));for(const b of v.breaks)td.append(this.node('small',b.quantity+'+ '+this.money(b.price)));row.append(td);
   }
   const total=this.node('td');const span=this.node('span','', 'kwo-row-total');span.dataset.total=group;total.append(span);const button=this.node('button',this.labels.add);button.type='button';button.dataset.addRow=group;total.append(button);row.append(total);body.append(row)
  }
  this.update();if(active){const focus=[...this.querySelectorAll('input')].find(i=>i.dataset.variant===active);if(focus&&!focus.disabled)focus.focus({preventScroll:true})}
 }
 update(){let count=0,total=0;const rows=new Map();for(const v of this.data.variants){const q=this.quantities.get(v.id)||0;const price=this.price(v,q+v.inCart);count+=q;total+=q*price;rows.set(this.group(v),(rows.get(this.group(v))||0)+q*price);const label=this.querySelector(`[data-price="${v.id}"]`);if(label)label.textContent=this.money(price)}this.querySelectorAll('[data-total]').forEach(n=>n.textContent=this.money(rows.get(n.dataset.total)||0));this.querySelector('[data-selection]').textContent=count+' '+this.labels.units+' · '+this.money(total);this.querySelector('[data-count]').textContent=this.data.cartCount;this.querySelectorAll('[data-add-all],[data-add-row]').forEach(b=>b.disabled=this.preview||this.busy||!this.ready);this.querySelector('[data-clear]').disabled=this.busy;this.setAttribute('aria-busy',String(this.busy))}
 status(message){this.querySelector('.kwo-status').textContent=message}
 failRefresh(){this.ready=false;this.status(this.labels.stale);this.render()}
 async refresh(){
  if(this.refreshing)return this.refreshing;
  this.refreshing=(async()=>{const url=new URL(window.location.href);url.searchParams.set('section_id',this.dataset.section);url.searchParams.set('_kwo',Date.now());this.controller=new AbortController();const timeout=setTimeout(()=>this.controller.abort(),12000);try{const response=await fetch(url,{credentials:'same-origin',cache:'no-store',signal:this.controller.signal});if(!response.ok)throw Error('refresh');const doc=new DOMParser().parseFromString(await response.text(),'text/html');const node=doc.querySelector('kareno-wholesale-order [data-order-data]');if(!node)throw Error('access');const next=JSON.parse(node.textContent);if(!next.b2b||!next.companyLocation||next.companyLocation!==this.data.companyLocation)throw Error('account');const changed=JSON.stringify(this.data.variants.map(v=>[v.id,v.price,v.breaks]))!==JSON.stringify(next.variants.map(v=>[v.id,v.price,v.breaks]));this.data=next;this.ready=true;this.render();if(changed)this.status(this.labels.priceChanged);return changed}finally{clearTimeout(timeout)}})();try{return await this.refreshing}finally{this.refreshing=null}
 }
 async add(group){
  if(this.busy||this.preview||!this.ready)return;this.busy=true;this.update();this.querySelectorAll('input').forEach(i=>i.disabled=true);this.status(this.labels.updating);let posted=false;
  try{
   const changed=await this.refresh();if(changed){this.status(this.labels.priceChanged);return}const chosen=this.data.variants.filter(v=>(group===undefined||this.group(v)===group)&&(this.quantities.get(v.id)||0)!==0);if(!chosen.length){this.status(this.labels.select);return}const invalid=chosen.find(v=>!this.valid(v,this.quantities.get(v.id)));if(invalid){this.status(this.labels.invalid);return}
   const items=chosen.map(v=>({id:v.id,quantity:this.quantities.get(v.id)}));const root=this.dataset.root.endsWith('/')?this.dataset.root:this.dataset.root+'/';const response=await fetch(root+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});const result=await response.json();if(!response.ok||result.status>=400)throw Error(this.labels.error+(typeof result.description==='string'?' '+result.description:''));posted=true;chosen.forEach(v=>this.quantities.delete(v.id));await this.refresh();this.status(this.labels.added);document.dispatchEvent(new CustomEvent('cart:refresh'));
  }catch(error){this.status(posted?this.labels.added+' '+this.labels.stale:(error.message?.startsWith(this.labels.error)?error.message:this.labels.error));try{await this.refresh()}catch{this.ready=false}}
  finally{this.busy=false;this.render()}
 }
});

  } catch(e) { console.error(e); }
})();
})();
